/**
 * Add-on product image zoom (lightbox)
 * - Click add-on image to open in overlay
 * - Blue overlay background
 * - Round X close button
 */
(function () {
  'use strict';

  if (window.__keranovaAddonImageZoomInitialized) return;
  window.__keranovaAddonImageZoomInitialized = true;

  const SELECTOR_TRIGGER = '[data-addon-image-zoom-trigger]';

  function buildOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'addon-image-zoom-overlay';
    overlay.setAttribute('hidden', 'hidden');

    overlay.innerHTML = `
      <div class="addon-image-zoom-dialog" role="dialog" aria-modal="true" aria-label="Image zoom">
        <button type="button" class="addon-image-zoom-close" aria-label="Close image zoom">
          <span aria-hidden="true" class="addon-image-zoom-close-x">×</span>
        </button>
        <img class="addon-image-zoom-image" alt="" loading="eager" decoding="async" />
      </div>
    `;

    document.body.appendChild(overlay);
    return overlay;
  }

  function isOpen(overlay) {
    return !overlay.hasAttribute('hidden');
  }

  function openOverlay(overlay, { src, alt, triggerEl }) {
    if (!src) return;

    const img = overlay.querySelector('.addon-image-zoom-image');
    const closeBtn = overlay.querySelector('.addon-image-zoom-close');

    overlay.__lastTriggerEl = triggerEl || null;

    img.src = src;
    img.alt = alt || '';

    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('addon-image-zoom--open');

    // Focus close button for accessibility
    if (closeBtn) closeBtn.focus();
  }

  function closeOverlay(overlay) {
    if (!isOpen(overlay)) return;

    const img = overlay.querySelector('.addon-image-zoom-image');
    overlay.setAttribute('hidden', 'hidden');
    document.documentElement.classList.remove('addon-image-zoom--open');

    // Reset src to stop downloading large images if user closes quickly
    if (img) {
      img.src = '';
      img.alt = '';
    }

    const last = overlay.__lastTriggerEl;
    overlay.__lastTriggerEl = null;
    if (last && typeof last.focus === 'function') last.focus();
  }

  function init() {
    const overlay = buildOverlay();

    // Close when clicking backdrop (but not the dialog)
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeOverlay(overlay);
    });

    // Close button
    overlay.querySelector('.addon-image-zoom-close')?.addEventListener('click', () => closeOverlay(overlay));

    // ESC closes
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen(overlay)) {
        e.preventDefault();
        closeOverlay(overlay);
      }
    });

    // Event delegation: any add-on zoom trigger
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest(SELECTOR_TRIGGER);
      if (!trigger) return;

      const src = trigger.getAttribute('data-addon-image-zoom-src');
      const alt = trigger.getAttribute('data-addon-image-zoom-alt') || trigger.getAttribute('aria-label') || '';

      openOverlay(overlay, { src, alt, triggerEl: trigger });
    });

    // Keyboard open (Enter/Space)
    document.addEventListener('keydown', (e) => {
      if (!(e.key === 'Enter' || e.key === ' ')) return;
      const trigger = e.target && e.target.closest ? e.target.closest(SELECTOR_TRIGGER) : null;
      if (!trigger) return;

      e.preventDefault();

      const src = trigger.getAttribute('data-addon-image-zoom-src');
      const alt = trigger.getAttribute('data-addon-image-zoom-alt') || trigger.getAttribute('aria-label') || '';
      openOverlay(overlay, { src, alt, triggerEl: trigger });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
